import { FC, CSSProperties } from 'react';
import RemoveOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { WbBadge } from '../../WbBadge';
import { NotStartedIcon as NotStarted } from './Icons';
import { useStyles } from './style';
import { WbInfoTooltip } from '../../WbInfoTooltip';

interface Props {
  style?: CSSProperties;
  variant?: 'reduced' | 'default';
}

export const NotStartedIcon: FC<Props> = ({ style, variant = 'default' }) => {
  const classes = useStyles();

  return (
    <WbInfoTooltip
      variant={variant === 'reduced' ? undefined : 'provided-button'}
      title="At least one error was encountered in this execution due to a previous policy, so this check was not executed at all"
      icon={
        variant === 'reduced' ? (
          <span>
            <NotStarted className={`${classes.icon}`} style={style} />
          </span>
        ) : (
          <WbBadge
            variant="disabled"
            startIcon={<RemoveOutlineIcon fontSize="small" />}
          >
            Not Started
          </WbBadge>
        )
      }
    />
  );
};
